<template>
  <div class="app-container goods-detail">
    <basic-container>
      <el-tabs v-model="activeName" @tab-click="onTabShow">
        <el-tab-pane label="基本资料" name="detail">
          <el-row class="goods-detail-item">
            <el-col :span="4">标题:</el-col>
            <el-col :span="16">{{ goodsDetail.name | formatDefaultVal }}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">封面图片:</el-col>
            <el-col :span="16">
              <div class="goods-cover-image">
                <img :src="goodsDetail.coverImg">
              </div>
            </el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">详情图片:</el-col>
            <el-col :span="16">
              <div class="goods-cover-image">
              <viewer>
                <img v-for="(src, index) in goodsDetail.attachments" :key="index" :src="src.attachmentUrl">
              </viewer>
              </div>
            </el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">描述:</el-col>
            <el-col :span="16">
              <div v-html="goodsDetail.description"></div>
            </el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">使用须知:</el-col>
            <el-col :span="16">
              <div v-html="goodsDetail.usageNote"></div>
            </el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">发布者昵称:</el-col>
            <el-col :span="16">
              {{ goodsDetail.creator }}
            </el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">商品分类:</el-col>
            <el-col :span="16">{{ goodsDetail.goodsTypes | formatDefaultVal }}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">状态:</el-col>
            <el-col :span="16">{{ goodsDetail.isBanned }}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">下架原因:</el-col>
            <el-col :span="16">{{ goodsDetail.banComment | formatDefaultVal }}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">创建时间:</el-col>
            <el-col :span="16">{{ goodsDetail.insertedTime | formatDefaultVal }}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">积分值:</el-col>
            <el-col :span="16">{{ goodsDetail.rewardValue }}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">折扣价:</el-col>
            <el-col :span="16">{{goodsDetail.discount}}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">库存:</el-col>
            <el-col :span="16">{{goodsDetail.sku}}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">销量:</el-col>
            <el-col :span="16">{{goodsDetail.sales}}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">剩余库存:</el-col>
            <el-col :span="16">{{goodsDetail.remainSku}}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">兑换限制:</el-col>
            <el-col :span="16">{{goodsDetail.exchangeLimit}}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">核销类型:</el-col>
            <el-col :span="16">{{goodsDetail.redeemType}}</el-col>
          </el-row>
          <el-row class="goods-detail-item">
            <el-col :span="4">置顶级别:</el-col>
            <el-col :span="16">{{goodsDetail.sort}}</el-col>
          </el-row>
        </el-tab-pane>
      </el-tabs>
      <el-button round @click="handleBack">返回</el-button>
    </basic-container>
  </div>
</template>

<script>
import { getGoods } from '@/api/mall/goods';
import { redeemTypeOptions } from '@/const/crud/mall/goods';
import {mapGetters} from "vuex";

export default {
  data() {
    return {
      id: 0,
      targetType: 0,
      activeName: "detail",
      goodsDetail:{
        id: undefined,
        name: "",
        description: "",
        rewardValue: 0,
        discount: 0,
        coverImg: "",
        redeemType: "",
        usageNote: "",
        sku: 0,
        sales: 0,
        remainSku: 0,
        isBanned: "",
        banComment: "",
        exchangeLimit: "",
        sort: 0,
        creator: "",
        insertedTime: "",
        attachments: [],
        goodsTypes: [],
      },
    }
  },
  computed: {
    ...mapGetters(['permissions']),
  },
  async mounted() {
    await this.initDetail(this.$route.params.id)
  },
  filters: {
    formatDefaultVal(val) {
      return val ? val : '--';
    },
  },
  methods: {
    onTabShow(tab) {
      switch (tab.name) {
        case 'history':
          this.getGoodsHistoryList();
          break;
      }
    },
    async initDetail(id) {
      const response = await getGoods(id);
      if (response.status == 200) {
        this.formatGoodsDetail(response.data.data);
      } else {
        this.$message({
          showClose: true,
          message: '无法查看该商品详情',
          type: 'error'
        });
      }
    },
    formatGoodsDetail(data) {
      this.id = data.id;
      this.goodsDetail.id = data.id;
      this.goodsDetail.name = data.name;
      this.goodsDetail.description = data.description;
      this.goodsDetail.rewardValue = data.rewardValue || 0;
      this.goodsDetail.discount = data.discount || 0;
      this.goodsDetail.coverImg = data.coverImg;
      this.goodsDetail.redeemType = redeemTypeOptions.find(item => item.value === data.redeemType).label || '其他';
      this.goodsDetail.usageNote = data.usageNote;
      this.goodsDetail.sku = data.sku || 0;
      this.goodsDetail.sales = data.sku - data.remainSku;
      this.goodsDetail.remainSku = data.remainSku || 0;
      this.goodsDetail.isBanned = data.isBanned ? '已下架' : '正常';
      this.goodsDetail.banComment = data.banComment;
      if (data.exchangeLimit === -1) {
        this.goodsDetail.exchangeLimit = '无限制'
      } else {
        this.goodsDetail.exchangeLimit = data.exchangeLimit || 0;
      }
      this.goodsDetail.sort = data.sort || 0;
      this.goodsDetail.creator = data.creator;
      this.goodsDetail.insertedTime = data.insertedTime;
      this.goodsDetail.attachments = data.attachments;
      this.goodsDetail.goodsTypes = [...new Set(data.goodsTypes.map(item => {return item.typeName}))].join('、');
    },
    handleBack() {
      this.$router.push({
        path: '/mall/goods'
      })
    },
  },
}
</script>

<style lang="scss" scoped>

.goods-detail {
  .goods-detail-item {
    font-size: 16px;
    margin: 10px 0;
    &-button {
      margin: 0 0;
      color: #409EFF;
      text-align: center;
    }
  }
  &-item-picture-right {
    font-size: 16px;
    display: table-cell;
    &-item {
      display: inline-block;
      margin-right: 5px;
      margin-top: 5px;
    }
    &-goodser {
      position: relative;
      &-icon {
        position: absolute;
        color: #ffffff;
        top: 30px;
        left: 30px;
        font-size: 40px;
      }
      &-icon:hover {
        color: rgba(249, 129, 55, 0.9);
      }
    }
  }
}

.vue-poll .ans-cnt .ans .bg{
  position: absolute;
  width: 0;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 0;
  background-color: #409eff;
  border-top-left-radius: 5px;
  border-bottom-left-radius: 5px;
}
.goods-cover-image {
  display: flex;
  width: fit-content;
  flex-wrap: wrap;
  cursor: pointer;
  img {
    padding: 5px;
    width: 52px;
    height: 52px;
    object-fit: cover;
    max-width: 100%;
  }
}
.mc-img {
  max-width: 100%;
}
/deep/.el-dialog__body {
  padding : 10px 20px 10px 20px;
}
</style>
